<template>
  <Drawer
    title="修改密码"
    v-model="modifyStatus"
    width="300"
    :mask-closable="false"
    :closable="false"
    :styles="drawerStyles"
  >
    <Form :label-width="80" :model="form" :rules="rules" ref="modifyRef" inline>
      <FormItem label="原密码" prop="oldPassword">
        <Input type="password" v-model="form.oldPassword"/>
      </FormItem>
      <FormItem label="新密码" prop="newPassword">
        <Input type="password" v-model="form.newPassword"/>
      </FormItem>
      <FormItem label="确认密码" prop="rePassword">
        <Input type="password" v-model="form.rePassword"/>
      </FormItem>
    </Form>
    <div class="drawer-footer">
      <Button style="margin-right: 8px" @click="cancel">取消</Button>
      <Button type="primary" :loading="submitLoading" @click="ok">确定</Button>
    </div>
  </Drawer>
</template>

<script>
  export default {
    name: 'ModifyPassword',
    data () {
      const validateSame = (r, v, cb) => {
        this.$refs['modifyRef'].validateField('rePassword')
        cb()
      }
      const validateIsSame = (r, v, cb) => {
        if (this.form.newPassword && this.form.newPassword !== v) {
          cb(new Error('两次输入的密码不一致!'))
        }
        cb()
      }
      return {
        modifyStatus: false,
        form: {
          oldPassword: null,
          newPassword: null,
          rePassword: null
        },
        rules: {
          oldPassword: [
            { required: true, message: '请输入初始密码', trigger: 'blur' }
          ],
          newPassword: [
            { required: true, message: '请输入新密码', trigger: 'blur' },
            { validator: validateSame }
          ],
          rePassword: [
            { required: true, message: '请输入确认密码', trigger: 'blur' },
            { validator: validateIsSame }
          ]
        }
      }
    },
    methods: {
      cancel () {
        this.modifyStatus = false
        this.$refs['modifyRef'].resetFields()
      },
      async ok () {
        let validate = await this.$refs['modifyRef'].validate(v => v)
        validate && this.doPost()
      },
      async doPost () {
        let query = {
          oldPassword: this.form.oldPassword,
          modifyPassword: this.form.newPassword
        }
        this.submitLoading = true
        let { succ } = await this.$http.modifyPassword(query)
        this.submitLoading = false
        if (succ) {
          this.$Message.success('修改密码成功!')
          this.cancel()
        }
      }
    }
  }
</script>

<style scoped lang="less">
  .drawer-footer {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
  }
</style>
